import { useCallback, useMemo } from 'react';

import { getTaskPhotosMap, TaskPhoto } from '@kaiizen/kai-reports';
import { ScanRootOptimized, ScanTaskOptimized } from '@kaiizen/kai-scan-template-system';

export const useTaskPhotosLookup = (
  scanRoot?: ScanRootOptimized,
  includeTaskPhotos: boolean = true,
) => {
  const taskPhotosMap = useMemo(
    () => (!scanRoot || !includeTaskPhotos) ? new Map<string, TaskPhoto[]>() : getTaskPhotosMap(scanRoot),
    [scanRoot, includeTaskPhotos],
  );

  return useCallback((task: ScanTaskOptimized) => taskPhotosMap.get(task.id) ?? [], [taskPhotosMap]);
};

export type GetTaskPhoto = (task: ScanTaskOptimized) => TaskPhoto[];
